export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10218.3c5db378.jpg";